import { render, staticRenderFns } from "./AllMy.vue?vue&type=template&id=5b817ac3&scoped=true&"
import script from "./AllMy.vue?vue&type=script&lang=js&"
export * from "./AllMy.vue?vue&type=script&lang=js&"
import style0 from "./AllMy.vue?vue&type=style&index=0&id=5b817ac3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b817ac3",
  null
  
)

export default component.exports